import { motion } from "framer-motion";
import { GraduationCap, Briefcase, Sparkles, Wrench } from "lucide-react";

const secondary = [
  { icon: Briefcase, label: "Agencies", tagline: "Never lose a client enquiry to slow follow up again" },
  { icon: Sparkles, label: "Med Spas", tagline: "Fill your calendar without chasing leads manually" },
  { icon: Wrench, label: "Service Businesses", tagline: "Respond to every missed call before your competitor does" },
];

export default function WhoItsFor() {
  return (
    <section data-testid="who-its-for-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-14 md:mb-16"
        >
          <h2
            data-testid="who-its-for-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight max-w-4xl"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Built for coaches, consultants, and any business that runs on appointments.
          </h2>
        </motion.div>

        {/* Primary — Coaches */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          data-testid="coaches-tile"
          className="bg-zinc-900 border-2 border-blue-500/25 rounded-2xl p-8 md:p-10 mb-5 shadow-[0_0_40px_rgba(59,130,246,0.06)]"
        >
          <div className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 rounded-xl bg-blue-500/10 flex items-center justify-center">
              <GraduationCap size={22} className="text-blue-400" />
            </div>
            <div>
              <h3 className="text-white text-xl font-bold" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Coaches & Consultants
              </h3>
              <span className="text-blue-400 text-xs font-semibold uppercase tracking-wider">Primary</span>
            </div>
          </div>
          <p className="text-zinc-400 text-base leading-relaxed max-w-3xl">
            You're running traffic. People are opting in. But half of them never book a call. Your AI follows up with every single one, qualifies them on your criteria, and gets them booked — while you're coaching, creating, or off the clock.
          </p>
        </motion.div>

        {/* Secondary tiles */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {secondary.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.08 }}
                data-testid={`secondary-tile-${i}`}
                className="bg-zinc-900/40 border border-white/[0.06] rounded-2xl p-6 hover:border-white/10 transition-all duration-300"
              >
                <Icon size={20} className="text-zinc-500 mb-3" />
                <h4 className="text-white text-base font-bold mb-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {item.label}
                </h4>
                <p className="text-zinc-500 text-sm leading-relaxed">{item.tagline}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
